<div>
  <strong i18n class="text-muted title float-left sm-flex">
    <a class="text-muted sm-flex sm-items-center hover:sm-no-underline" (click)="collapse = !collapse">
      <i
        class="cc-icon sm-pr-1"
        [class.cc-icon-arrow-up]="collapse"
        [class.cc-icon-arrow-down]="!collapse"
      ></i> </a
    >{{ title }}
  </strong>
  <i *ngIf="readonly" class="float-right text-muted cc-icon cc-icon-lock-closed"></i>
  <span class="clearfix"></span>
</div>
<div [hidden]="collapse">
  <div *ngIf="isWorking" class="text-center">
    <i class="cc-icon cc-icon-spinner-lg"></i>
  </div>
  <div class="table-wrapper">
    <table class="table mt-3">
      <thead class="text-muted">
        <tr>
          <th i18n>Photo Tag Group Name</th>
          <th class="w-50" i18n>Preview</th>
          <th i18n class="text-right">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let t of tagGroups" (mouseenter)="selectedList = t">
          <td>{{ t.name }}</td>
          <td>
            <select
              multiple
              class="form-control"
              [ngClass]="{ 'long-select': t.tags.length > 10 }"
              [disabled]="readonly"
            >
              <option *ngFor="let tag of t.tags">{{ tag }}</option>
            </select>
          </td>
          <td class="text-right">
            <div [hidden]="readonly">
              <div ngbDropdown class="d-inline-block position-relative">
                <button type="button" class="btn btn-secondary btn-action-dropdown" ngbDropdownToggle>
                  <span i18n>Actions</span>
                </button>
                <div class="dropdown-menu" ngbDropdownMenu>
                  <a class="dropdown-item btn-edit-tag tag-action-item" (click)="editTagGroup(t)">
                    <i class="cc-icon cc-icon-pencil"></i><span i18n>Edit</span>
                  </a>
                  <div class="dropdown-divider"></div>
                  <a
                    class="dropdown-item btn-delete-tag tag-action-item"
                    (click)="removeTagGroup(t.id, t.name)"
                  >
                    <i class="cc-icon cc-icon-delete sm-text-default-red"></i
                    ><span class="sm-text-default-red" i18n>Delete</span>
                  </a>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<hr class="hr" />
<div>
  <button *ngIf="!readonly" type="button" class="btn-add-tag btn btn-primary" i18n (click)="addTagGroup()">
    Add tag group
  </button>
</div>
